import request from '@/utils/request'

export function dictData(dictType) {
    return request({
        url: '/system/dict/data/type/' + dictType,
        method: 'get',
    })
}
